(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sparqwear-pdp-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    const days = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
    const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    const addBiz = (d, n) => {
      const x = new Date(d);
      while (n > 0) {
        x.setDate(x.getDate() + 1);
        if (x.getDay() !== 0 && x.getDay() !== 6) n--;
      }
      return x;
    };
    const fmt = (d) => `${d.getDate()} ${months[d.getMonth()]} ${days[d.getDay()]}`;
    const run = () =>
      document.querySelectorAll('[data-sqw-delivery]').forEach((el) => {
        const cutoff = +el.dataset.cutoff || 16;
        const now = new Date();
        let start = new Date(now);
        const weekend = now.getDay() === 0 || now.getDay() === 6;
        if (now.getHours() >= cutoff || weekend) start = addBiz(now, 1);
        const a = addBiz(start, +el.dataset.min || 1);
        const b = addBiz(start, +el.dataset.max || 2);
        const out = el.querySelector('[data-sqw-delivery-date]');
        if (out) out.textContent = a.toDateString() === b.toDateString() ? fmt(a) : `${fmt(a)} – ${fmt(b)}`;
        const c = el.querySelector('[data-sqw-delivery-cutoff]');
        if (c && !weekend && now.getHours() < cutoff) c.hidden = false;
      });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sparqwear-pdp-sosyal-kanit"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = (el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const items = [...el.querySelectorAll('.sqw-proof__quotes li')];
      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0;
      setInterval(() => {
        items[i].hidden = true;
        i = (i + 1) % items.length;
        items[i].hidden = false;
      }, 4500);
    };
    const run = () => document.querySelectorAll('[data-sqw-proof]').forEach(start);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:block:select', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
